import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router';
import Layout from '../../components/Layout/Layout.jsx';
import AnalysisTable from '../../components/AnalysisTable/AnalysisTable.jsx';
import AnalysedFile from '../../components/AnalysedFile/AnalysedFile.jsx';
import './Analysis.css';

const Analysis = () => {
  const { file_id } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    console.log(file_id);
  }, [file_id]);

  // Check if there are query parameters (like filepath filter)
  const hasQueryParams = searchParams.toString().length > 0;

  return (
    <Layout>
      <div className="analysis-main">
        {file_id && !hasQueryParams ? (
          <AnalysedFile fileId={file_id} />
        ) : (
          <AnalysisTable />
        )}
      </div>
    </Layout>
  );
};

export default Analysis;
